import Back from "Components/Back";
import Loader from "Components/Loader";
import { useGetInventoryHistoryQuery } from "hooks/InventoryManagement/useGetInventoryHistoryQuery";
import DashboardLayout from "Layout/DashboardLayout";
import { useParams } from "react-router-dom";

const InventoryPreview = () => {
  const { id } = useParams();
  const { data, isPending } = useGetInventoryHistoryQuery(id);

  if (isPending) {
    return (
      <DashboardLayout title="Inventory" back={false}>
        <Loader />
      </DashboardLayout>
    );
  }

  if (!data) {
    return (
      <DashboardLayout title="Inventory" back={false}>
        <div className="pl-[20px] pr-[40px]">No data available</div>
      </DashboardLayout>
    );
  }

  const {
    purpose,
    totalItem,
    totalAmount,
    adminId,
    no,
    products,
    branchId,
    description,
    createdAt,
    type,
  } = data.data;

  return (
    <DashboardLayout title="Preview Inventory" back={false}>
      <div className="px-8 py-6 bg-gray-100 rounded-lg">
        <Back />
        <h2 className="text-2xl font-semibold mb-6 text-gray-800 mt-[40px]">
          Inventory Details
        </h2>

        {/* Inventory Overview */}
        <div className="mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
            <div>
              <p>
                <span className="font-bold text-gray-700">Purpose:</span>{" "}
                {purpose}
              </p>
              <p>
                <span className="font-bold text-gray-700">Inventory No:</span>{" "}
                {no}
              </p>
              <p>
                <span className="font-bold text-gray-700">Type:</span> {type}
              </p>
            </div>
            <div>
              <p>
                <span className="font-bold text-gray-700">Total Items:</span>{" "}
                {totalItem}
              </p>
              <p>
                <span className="font-bold text-gray-700">Total Amount:</span> $
                {totalAmount}
              </p>
              <p>
                <span className="font-bold text-gray-700">Created At:</span>{" "}
                {new Date(createdAt).toLocaleString()}
              </p>
            </div>
          </div>
          <p>
            <span className="font-bold text-gray-700">Description:</span>{" "}
            {description}
          </p>
        </div>

        {/* Branch Information */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Branch Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p>
                <span className="font-bold text-gray-700">Branch Name:</span>{" "}
                {branchId.name}
              </p>
              <p>
                <span className="font-bold text-gray-700">Address:</span>{" "}
                {branchId.address}
              </p>
            </div>
            <div>
              <p>
                <span className="font-bold text-gray-700">State:</span>{" "}
                {branchId.state}
              </p>
              <p>
                <span className="font-bold text-gray-700">Phone Number:</span>{" "}
                {branchId.phoneNumber}
              </p>
            </div>
          </div>
        </div>

        {/* Admin Information */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Admin Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p>
                <span className="font-bold text-gray-700">Name:</span>{" "}
                {adminId.firstName} {adminId.lastName}
              </p>
              <p>
                <span className="font-bold text-gray-700">Email:</span>{" "}
                {adminId.email}
              </p>
            </div>
            <div>
              <p>
                <span className="font-bold text-gray-700">Last Login:</span>{" "}
                {new Date(adminId.lastLogin).toLocaleString()}
              </p>
              <p>
                <span className="font-bold text-gray-700">Phone Number:</span>{" "}
                {adminId.phoneNumber || "N/A"}
              </p>
            </div>
          </div>
        </div>

        {/* Products Section */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Products</h3>
          <div className="space-y-4">
            {products.map((product: any) => (
              <div key={product.id} className="p-4 bg-white shadow rounded-lg">
                <h4 className="text-lg font-semibold text-gray-700">
                  {product.name}
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
                  <div>
                    <p>
                      <span className="font-bold text-gray-600">
                        Product ID:
                      </span>{" "}
                      {product.productId}
                    </p>
                    <p>
                      <span className="font-bold text-gray-600">
                        Unit Quantity:
                      </span>{" "}
                      {product.unitQuantity}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span className="font-bold text-gray-600">
                        Old Stock Count:
                      </span>{" "}
                      {product.oldStockCount}
                    </p>
                    <p>
                      <span className="font-bold text-gray-600">
                        New Stock Count:
                      </span>{" "}
                      {product.newStockCount}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default InventoryPreview;
